import React from 'react';
import classNames from 'classnames';

import { ThemeMode, useThemeMode } from '@contexts/ThemeModeContext';

type ThemeModeToggleProps = {
  compact?: boolean;
};

const OPTIONS: { label: string; value: ThemeMode }[] = [
  { label: 'System', value: 'system' },
  { label: 'Light', value: 'light' },
  { label: 'Dark', value: 'dark' },
];

const ThemeModeToggle: React.FC<ThemeModeToggleProps> = ({ compact = false }) => {
  const { mode, setMode } = useThemeMode();

  return (
    <div
      className={classNames(
        'inline-flex items-center rounded-full border border-white/30 bg-white/10 p-1 backdrop-blur-sm',
        compact ? 'scale-90 origin-right' : '',
      )}
      aria-label="Theme mode"
      role="group"
    >
      {OPTIONS.map(({ label, value }) => {
        const isActive = mode === value;

        return (
          <button
            key={value}
            type="button"
            className={classNames(
              'rounded-full px-3 py-1 text-xs font-semibold transition-colors duration-150',
              isActive ? 'bg-white text-gray-900' : 'bg-transparent text-white/85 hover:text-white',
            )}
            aria-pressed={isActive}
            onClick={() => setMode(value)}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default ThemeModeToggle;
